 
 
export enum Orientation {
  HORIZONTAL = 'H',
  VERTICAL = 'V',
  BOTH = 'B',
}
